module.exports = __webpack_public_path__ + "static/media/RingRound.15767dd3.mp3";